import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/Grey/Chevron Right.svg'
import _imports_1 from '@/assets/img/Icons/Grey/Back.svg'


const _withScopeId = n => (_pushScopeId("data-v-d525384a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-bar-nps-type" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "asknicely-icon-loader_static icon-right"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  class: "icon-right"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  id: "sub-options",
  class: "option-set"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon-back"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "asknicely-icon-loader_static icon-right"
}
const _hoisted_9 = {
  key: 0,
  class: "numeric-options"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uk-icon-caret-down" }, null, -1))
const _hoisted_11 = { id: "filterRuleOperatorOptions" }
const _hoisted_12 = { class: "operator-options" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "numeric-options"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uk-icon-caret-down" }, null, -1))
const _hoisted_16 = { class: "operator-options" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 2,
  class: "option-selected-container"
}
const _hoisted_21 = { class: "option-selected-box" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "del" }, "×", -1))
const _hoisted_24 = {
  key: 3,
  class: "search-container"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["title"]
const _hoisted_27 = {
  key: 1,
  class: "sub-info"
}
const _hoisted_28 = {
  key: 2,
  class: "sub-info"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-more" }, " Please wait, loading filter values... ", -1))
const _hoisted_30 = {
  key: 1,
  class: "sticky-cta"
}
const _hoisted_31 = { class: "cta-container" }
const _hoisted_32 = { class: "option-back" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_FilterModalMobileHeader = _resolveComponent("FilterModalMobileHeader")!
  const _component_SearchBox = _resolveComponent("SearchBox")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dropdown, {
      ref: "dropdown",
      "on-open": _ctx.clearRuleSubOption,
      modal: _ctx.tsMobileView,
      disabled: !_ctx.hasNetworkConnection
    }, {
      trigger: _withCtx(() => [
        _createVNode(_component_BaseButton, {
          secondary: "",
          muted: "",
          icon: _ctx.hasNetworkConnection ? 'plus' : '',
          disabled: !_ctx.hasNetworkConnection
        }, {
          default: _withCtx(() => [
            (!_ctx.tsMobileView)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("add ")
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode("filter ")
          ], undefined, true),
          _: 1
        }, 8, ["icon", "disabled"])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["options", { 'ts-modal-c': _ctx.tsMobileView }])
        }, [
          (_ctx.tsMobileView)
            ? (_openBlock(), _createBlock(_component_FilterModalMobileHeader, {
                key: 0,
                title: "Add filter",
                onClose: _ctx.closeModal
              }, null, 8, ["onClose"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["options-c", {
                            'mobile-view-modal-content-margin': _ctx.tsMobileView,
                        }])
          }, [
            _withDirectives(_createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkFilterRuleOptions, (optionSet, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: key,
                  class: "option-set"
                }, [
                  _createElementVNode("h5", null, _toDisplayString(key), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionSet, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: option.value,
                      class: "option",
                      onClick: 
                                        (evt) =>
                                            _ctx.initSubOptions(option.value, key)
                                    
                    }, [
                      _createElementVNode("span", null, _toDisplayString(option.label
                                            .replace(/_c$/g, '')
                                            .replace(/_/g, ' ')), 1),
                      (
                                            _ctx.filterLoadingRuleSubOption ===
                                            option.value
                                        )
                        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                        : (_openBlock(), _createElementBlock("img", _hoisted_4))
                    ], 8, _hoisted_2))
                  }), 128))
                ]))
              }), 128))
            ], 512), [
              [_vShow, !_ctx.showSubOptions]
            ]),
            (_ctx.filterActive)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "option option-back",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedSubOptions && _ctx.clearSelectedSubOptions(...args)))
                    }, [
                      _hoisted_7,
                      _createElementVNode("div", null, _toDisplayString(_ctx.activeRuleOptionLabel), 1),
                      (_ctx.filterPatching)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.filterIsNumeric)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFilterRuleOperatorOptions && _ctx.handleFilterRuleOperatorOptions(...args)))
                          }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(_ctx.filterRuleOperator.name) + " ", 1),
                              _hoisted_10
                            ])
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_11, [
                            _createElementVNode("ul", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operators, (operator) => {
                                return _withDirectives((_openBlock(), _createElementBlock("li", {
                                  key: operator.name,
                                  onClick: ($event: any) => (
                                                    _ctx.handleSelectOperator(
                                                        operator
                                                    )
                                                )
                                }, _toDisplayString(operator.name), 9, _hoisted_13)), [
                                  [_vShow, 
                                                    operator.name !==
                                                    _ctx.filterRuleOperator.name
                                                ]
                                ])
                              }), 128))
                            ])
                          ], 512), [
                            [_vShow, _ctx.showFilterRuleOperatorOptions]
                          ])
                        ]))
                      : (
                                        !_ctx.strOperatorExclude.includes(
                                            _ctx.filterActiveRuleSubOption
                                        )
                                    )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFilterRuleOperatorOptions && _ctx.handleFilterRuleOperatorOptions(...args)))
                            }, [
                              _createElementVNode("div", null, [
                                _createTextVNode(_toDisplayString(_ctx.filterRuleOperator.name) + " ", 1),
                                _hoisted_15
                              ])
                            ]),
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", null, [
                                _createElementVNode("ul", _hoisted_16, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strOperators, (operator) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("li", {
                                      key: operator.name,
                                      onClick: ($event: any) => (
                                                        _ctx.handleSelectOperator(
                                                            operator
                                                        )
                                                    )
                                    }, _toDisplayString(operator.name), 9, _hoisted_17)), [
                                      [_vShow, 
                                                        operator.name !==
                                                        _ctx.filterRuleOperator.name
                                                    ]
                                    ])
                                  }), 128)),
                                  (_ctx.subOption === 'tag')
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.hashtagOperators, (operator) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("li", {
                                          key: operator.name,
                                          onClick: ($event: any) => (
                                                            _ctx.handleHashTagClickOption(
                                                                operator
                                                            )
                                                        )
                                        }, _toDisplayString(operator.name), 9, _hoisted_18)), [
                                          [_vShow, 
                                                            operator.name !==
                                                            _ctx.filterRuleOperator.name
                                                        ]
                                        ])
                                      }), 128))
                                    : _createCommentVNode("", true),
                                  (
                                                        _ctx.subOption ===
                                                        'case_assigned_user_id'
                                                    )
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.caseAssignedOperators, (operator) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("li", {
                                          key: operator.name,
                                          onClick: ($event: any) => (
                                                            _ctx.handleCaseAssignedClickOption(
                                                                operator
                                                            )
                                                        )
                                        }, _toDisplayString(operator.name), 9, _hoisted_19)), [
                                          [_vShow, 
                                                            operator.name !==
                                                            _ctx.filterRuleOperator.name
                                                        ]
                                        ])
                                      }), 128))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ], 512), [
                              [_vShow, _ctx.showFilterRuleOperatorOptions]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                    (_ctx.mode === 'multi')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSubOptions, (selectedSubOption) => {
                              return _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: selectedSubOption.value,
                                class: "option-selected",
                                onClick: _withModifiers(
                                                (evt) =>
                                                    _ctx.removeFromSelectedSubOptions(
                                                        selectedSubOption
                                                    )
                                            , ["stop"])
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.getOptionValueLabel(
                                                    selectedSubOption
                                                )) + " ", 1),
                                _hoisted_23
                              ], 8, _hoisted_22)), [
                                [_vShow, 
                                                selectedSubOption.value !==
                                                    'any' &&
                                                (_ctx.filterRuleOperator.operator ===
                                                    'in' ||
                                                    _ctx.filterRuleOperator.operator ===
                                                        'notin')
                                            ]
                              ])
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (
                                        _ctx.filterActiveRuleSubOptions.length ||
                                        _ctx.filterSearchTerm
                                    )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (
                                            (_ctx.filterSearchTerm ||
                                                _ctx.filterActiveRuleSubOptions.length >
                                                    5) &&
                                            (_ctx.filterRuleOperator.operator ===
                                                'in' ||
                                                _ctx.filterRuleOperator.operator ===
                                                    'notin')
                                        )
                            ? (_openBlock(), _createBlock(_component_SearchBox, {
                                key: 0,
                                value: _ctx.filterSearchTerm,
                                onInput: _ctx.onSearchInput
                              }, null, 8, ["value", "onInput"]))
                            : _createCommentVNode("", true),
                          (
                                            _ctx.filterRuleOperator.operator !==
                                                'in' &&
                                            _ctx.filterRuleOperator.operator !==
                                                'notin'
                                        )
                            ? (_openBlock(), _createBlock(_component_SearchBox, {
                                key: 1,
                                value: _ctx.filterSubOptionValue,
                                placeholder: "Number",
                                type: "number",
                                onInput: _ctx.onNumberInput
                              }, null, 8, ["value", "onInput"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_InfiniteScroll, {
                      "scroll-container-classes": "moment-infinite-scroll",
                      "load-more": _ctx.loadMoreContent,
                      "is-loading-more": _ctx.infiniteIsLoading,
                      "has-reached-end": _ctx.infiniteReachedTheEnd,
                      "scroll-end-class": "scroll-end-infinite"
                    }, {
                      loading: _withCtx(() => [
                        _hoisted_29
                      ]),
                      default: _withCtx(() => [
                        (
                                            _ctx.filterRuleOperator.operator ===
                                                'in' ||
                                            _ctx.filterRuleOperator.operator ===
                                                'notin'
                                        )
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.infiniteContent, (option) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: option.value,
                                class: "option",
                                onClick: 
                                                (evt) =>
                                                    _ctx.handleClickOption(option)
                                            
                              }, [
                                _createElementVNode("span", {
                                  "data-uk-tooltip": "",
                                  title: option.label
                                }, _toDisplayString(option.label), 9, _hoisted_26),
                                _createElementVNode("b", null, _toDisplayString(option.count), 1)
                              ], 8, _hoisted_25))
                            }), 128))
                          : _createCommentVNode("", true),
                        (
                                            !_ctx.infiniteIsLoading &&
                                            _ctx.showSubOptions &&
                                            _ctx.infiniteContent.length > 1 &&
                                            (_ctx.filterRuleOperator.operator ===
                                                'in' ||
                                                _ctx.filterRuleOperator.operator ===
                                                    'notin')
                                        )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.infiniteContent.length) + " Results Found ", 1))
                          : _createCommentVNode("", true),
                        (
                                            !_ctx.infiniteIsLoading &&
                                            _ctx.showSubOptions &&
                                            (_ctx.infiniteContent.length === 0 ||
                                                !_ctx.searchedResults().length) &&
                                            (_ctx.filterRuleOperator.operator ===
                                                'in' ||
                                                _ctx.filterRuleOperator.operator ===
                                                    'notin')
                                        )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, " no results found "))
                          : _createCommentVNode("", true)
                      ], undefined, true),
                      _: 1
                    }, 8, ["load-more", "is-loading-more", "has-reached-end"])
                  ])
                ], 512)), [
                  [_vShow, _ctx.showSubOptions]
                ])
              : _createCommentVNode("", true),
            (_ctx.filterActive)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_BaseButton, {
                        secondary: "",
                        click: _ctx.clearSelectedSubOptions
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Cancel")
                        ], undefined, true),
                        _: 1
                      }, 8, ["click"]),
                      (_ctx.mode == 'multi')
                        ? (_openBlock(), _createBlock(_component_BaseButton, {
                            key: 0,
                            primary: "",
                            click: _ctx.saveMultiFilter,
                            disabled: _ctx.hasFilterChanged
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.applyingLabel), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["click", "disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 512)), [
                  [_vShow, _ctx.showSubOptions]
                ])
              : _createCommentVNode("", true)
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["on-open", "modal", "disabled"])
  ]))
}